<script>
export default {
  props: {
    className: {
      type: String,
    },
    isButtonIcon: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
  },

  computed: {
    dynamicStyle() {
      return {
        color: this.color,
        cursor: (this.$attrs && this.$attrs.onClick) || this.isButtonIcon ? 'pointer' : 'auto',
      };
    },
  },
};
</script>

<template>
  <i :class="className" :style="dynamicStyle" />
</template>
